import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { AnalyticsScript } from '~/components/business/AnalyticsScript'
import classNames from 'classnames'
import { Header, HeaderType } from './header'
import { Footer } from './footer'
import { useStores } from '~/hooks/useStores'
import { LoginModal } from '~/components/pages/login/LoginModal'
import { RightBar } from '~/components/business/RightBar'
import { ResetPwdModal } from '~/components/pages/login/ResetPwdModal'

export const Layout: React.FC<{
  className?: string
  children: React.ReactNode
  headerType?: HeaderType
  footerClassName?: string
  headerClassName?: string
}> = observer(
  ({
    children,
    className,
    headerType = 'normal',
    footerClassName,
    headerClassName,
  }) => {
    const { store } = useStores()

    const isProd = process.env.NEXT_PUBLIC_NODE_ENV === 'production'
    const loginVisible = !!store.modal?.login
    const resetPwdVisible = !!store.modal?.resetPwd

    useEffect(() => {
      window.oncontextmenu = function (e) {
        // 大佬需求，不让右键下载图片
        if ((e?.target as any)?.nodeName === 'IMG') {
          e.preventDefault()
        }
      }
    }, [])

    return (
      <div className={classNames('min-h-screen min-w-[1400px]', className)}>
        <Header type={headerType} className={headerClassName} />
        <main
          style={{
            minHeight:
              headerType === 'no-margin'
                ? 'calc(100vh - 56px - 242px)'
                : 'calc(100vh - 56px - 242px - 24px)',
          }}
        >
          {children}
        </main>
        <Footer className={footerClassName} />
        {loginVisible && <LoginModal />}
        {resetPwdVisible && <ResetPwdModal />}
        <RightBar />
        {isProd && <AnalyticsScript />}
      </div>
    )
  }
)
